import * as SankeyPlusNodes from 'sankeyanimation/dist/src/SankeyPlusNodes'
import * as SankeyPlusForeignObject  from 'sankeyanimation/dist/src/SankeyPlusForeignObject'
import * as SankeyPlusLabels from 'sankeyanimation/dist/src/SankeyPlusLabels'
import * as SankeyPlusGradient from 'sankeyanimation/dist/src/SankeyPlusGradient'
import * as SankeyPlusViews from 'sankeyanimation/dist/src/SankeyPlusViews'
import * as SankeyPlusUtils from 'sankeyanimation/dist/src/SankeyPlusUtils'
import * as SankeyPlusMenuConfigurationLabels from 'sankeyanimation/dist/src/SankeyPlusMenuConfigurationLabels'
import * as SankeyPlusItemShortcut from 'sankeyanimation/dist/src/SankeyPlusItemShortcut'
import * as SankeyPlusConvert from 'sankeyanimation/dist/src/SankeyPlusConvert'

import { SankeyPlusDrawNodesIllustrationFType, SankeyPlusHyperLinkFType, PlusNodeClickEventFType, PlusNodeDragEventFType, SankeyPlusNodeIconFType, ContextNodeIconFType } from 'sankeyanimation/types/SankeyPlusNodesTypes'
import { PlusDrawNodesFOFType, SankeyPlusNodeFOFType } from 'sankeyanimation/types/SankeyPlusForeignObjectTypes'
import { PlusDrawLabelsFType,sankey_plus_min_width_and_heightFType,zone_selection_labelFType,sankey_plus_zoom_text_zoneFType} from 'sankeyanimation/types/SankeyPlusLabelsTypes'
import { SankeyPlusDrawArrowsFType, LinkStrokeFType, menu_conf_link_apparence_gradientFType } from 'sankeyanimation/types/SankeyPlusGradientTypes'
import { 
  MenuEnregistrerViewFType, OpenSankeyPlusCheckpointButtonFType, SankeyPlusBannerViewFType, 
  SankeyPlusMenuPreferenceViewFType,
  CheckCurrentViewSavedFType, FilterViewFType, GetDataFromViewFType, 
  keyHandlerFType, modal_transparent_view_attrFType,
  modal_view_not_savedFType, RecomputeViewsFType, 
  SelecteurViewFType, setValueFType, view_toastFType, view_toast_update_viewFType, 
  viewsAccordionFType, getSetDiagramFType 
} from 'sankeyanimation/types/SankeyPlusViewsTypes'
import { DragLegendPlusFType, SetSvgBgFType, PlusLinkSabotColorFType, ImportImageAsSvgBgFType, PlusItemExportFType, Modale_resolution_pngFType} from 'sankeyanimation/types/SankeyPlusUtilsTypes'
import { SankeyPlusMenuPreferenceLabelsFType, blur_ZDT_wysiwygFType, context_zdtFType, zdtMenuAsAccordeonItemType}from 'sankeyanimation/types/SankeyPlusMenuConfigurationLabelsTypes'
import { SankeyPlusShortcutFType } from 'sankeyanimation/types/SankeyPlusItemShortcutTypes'
import { 
  SankeyPlusDiagramSelectorFType, apply_transformation_opensankey_plus_elementsFType, 
  plus_sankey_layoutFType 
} from 'sankeyanimation/types/SankeyPlusConvertTypes'

// Import From SankeyPlus
export const SankeyPlusDrawNodesIllustration =
 SankeyPlusNodes.SankeyPlusDrawNodesIllustration as SankeyPlusDrawNodesIllustrationFType
export const PlusNodeClickEvent =
 SankeyPlusNodes.PlusNodeClickEvent as PlusNodeClickEventFType
export const PlusNodeDragEvent =
 SankeyPlusNodes.PlusNodeDragEvent as PlusNodeDragEventFType
export const PlusDrawNodesFO =
 SankeyPlusForeignObject.PlusDrawNodesFO as PlusDrawNodesFOFType
export const PlusDrawLabels =
 SankeyPlusLabels.PlusDrawLabels as PlusDrawLabelsFType
export const sankey_plus_min_width_and_height =
 SankeyPlusLabels.sankey_plus_min_width_and_height as sankey_plus_min_width_and_heightFType
export const zone_selection_label =
 SankeyPlusLabels.zone_selection_label as zone_selection_labelFType
export const sankey_plus_zoom_text_zone =
 SankeyPlusLabels.sankey_plus_zoom_text_zone as sankey_plus_zoom_text_zoneFType
export const SankeyPlusDrawArrows =
 SankeyPlusGradient.SankeyPlusDrawArrows as SankeyPlusDrawArrowsFType
export const LinkStroke =
 SankeyPlusGradient.LinkStroke as LinkStrokeFType
export const menu_conf_link_apparence_gradient =
 SankeyPlusGradient.menu_conf_link_apparence_gradient as menu_conf_link_apparence_gradientFType
export const GetDataFromView =
 SankeyPlusViews.GetDataFromView as GetDataFromViewFType
export const getSetDiagramFunc =
 SankeyPlusViews.getSetDiagramFunc as getSetDiagramFType
export const DragLegendPlus =
 SankeyPlusUtils.DragLegendPlus as DragLegendPlusFType
export const SetSvgBg =
 SankeyPlusUtils.SetSvgBg as SetSvgBgFType
export const PlusLinkSabotColor =
 SankeyPlusUtils.PlusLinkSabotColor as PlusLinkSabotColorFType

export const blur_ZDT_wysiwyg =
 SankeyPlusMenuConfigurationLabels.blur_ZDT_wysiwyg as blur_ZDT_wysiwygFType

export const SankeyPlusNodeIcon =
 SankeyPlusNodes.SankeyPlusNodeIcon as SankeyPlusNodeIconFType
export const ContextNodeIcon =
 SankeyPlusNodes.ContextNodeIcon as ContextNodeIconFType
export const SankeyPlusHyperLink =
 SankeyPlusNodes.SankeyPlusHyperLink as SankeyPlusHyperLinkFType
export const zdtMenuAsAccordeonItem =
 SankeyPlusMenuConfigurationLabels.zdtMenuAsAccordeonItem as zdtMenuAsAccordeonItemType

export const SankeyPlusMenuPreferenceLabels = 
  SankeyPlusMenuConfigurationLabels.SankeyPlusMenuPreferenceLabels as
   SankeyPlusMenuPreferenceLabelsFType
export const context_zdt = 
  SankeyPlusMenuConfigurationLabels.context_zdt as context_zdtFType
export const SankeyPlusShortcut = 
  SankeyPlusItemShortcut.SankeyPlusShortcut as SankeyPlusShortcutFType
export const SankeyPlusNodeFO = 
  SankeyPlusForeignObject.SankeyPlusNodeFO as SankeyPlusNodeFOFType
export const plus_sankey_layout = 
  SankeyPlusConvert.plus_sankey_layout as plus_sankey_layoutFType
export const apply_transformation_opensankey_plus_elements = 
  SankeyPlusConvert.apply_transformation_opensankey_plus_elements as 
  apply_transformation_opensankey_plus_elementsFType
export const SankeyPlusDiagramSelector = 
  SankeyPlusConvert.SankeyPlusDiagramSelector as SankeyPlusDiagramSelectorFType
export const ImportImageAsSvgBg = 
  SankeyPlusUtils.ImportImageAsSvgBg as ImportImageAsSvgBgFType

export const view_toast =
 SankeyPlusViews.view_toast as view_toastFType
export const view_toast_update_view =
 SankeyPlusViews.view_toast_update_view as view_toast_update_viewFType
export const setValue =
 SankeyPlusViews.setValue as setValueFType
export const FilterView =
 SankeyPlusViews.FilterView as FilterViewFType
export const RecomputeViews =
 SankeyPlusViews.RecomputeViews as RecomputeViewsFType
export const keyHandler =
 SankeyPlusViews.keyHandler as keyHandlerFType
export const SelecteurView =
 SankeyPlusViews.SelecteurView as SelecteurViewFType
export const viewsAccordion =
 SankeyPlusViews.viewsAccordion as viewsAccordionFType
export const CheckCurrentViewSaved =
 SankeyPlusViews.CheckCurrentViewSaved as CheckCurrentViewSavedFType
export const SankeyPlusBannerView =
 SankeyPlusViews.SankeyPlusBannerView as SankeyPlusBannerViewFType
export const SankeyPlusMenuPreferenceView =
 SankeyPlusViews.SankeyPlusMenuPreferenceView as SankeyPlusMenuPreferenceViewFType
export const modal_view_not_saved =
 SankeyPlusViews.modal_view_not_saved as modal_view_not_savedFType
export const modal_transparent_view_attr =
 SankeyPlusViews.modal_transparent_view_attr as modal_transparent_view_attrFType
export const MenuEnregistrerView =
 SankeyPlusViews.MenuEnregistrerView as MenuEnregistrerViewFType
export const OpenSankeyPlusCheckpointButton =
 SankeyPlusViews.OpenSankeyPlusCheckpointButton as OpenSankeyPlusCheckpointButtonFType 

export const PlusItemExport:PlusItemExportFType=SankeyPlusUtils.PlusItemExport

export const Modale_resolution_png:Modale_resolution_pngFType=SankeyPlusUtils.Modale_resolution_png
